import { type FC } from "react";
import { generatePath } from "react-router-dom";

import { Breadcrumb } from "@snapchat/snap-design-system";

import { AbsoluteRoute } from "../../core/routes";
import { BreadcrumbItem, breadcrumbContainer } from "../../lens/components/shared";
import { useSelectedOrganizationContainer } from "../../shared/hooks";
import { LinkStyled } from "../../shared/styles";

import { AllAssets, NewAssetTitle } from "./messages.generated";

export const AssetsBreadcrumb: FC = () => {
    const { orgId } = useSelectedOrganizationContainer();

    return (
        <div className={breadcrumbContainer}>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <LinkStyled to={generatePath(AbsoluteRoute.ORG_ASSETS, { orgId: orgId ?? "" })}>
                        <BreadcrumbItem>
                            <AllAssets />
                        </BreadcrumbItem>
                    </LinkStyled>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <BreadcrumbItem active={true}>
                        <NewAssetTitle />
                    </BreadcrumbItem>
                </Breadcrumb.Item>
            </Breadcrumb>
        </div>
    );
};
